"use strict";

(function () {
	var adpPopup = {};

	(function () {
		var $this;

		/*
		 * jQuery replacements.
		 *
		 * jQuery methods run over a SET of elements and silently no-op when that
		 * set is empty, so the helpers below take an "element-ish" value (an
		 * element, a CSS selector string or a list) and always return a plain
		 * array. That keeps the old "does nothing when nothing matched"
		 * behaviour instead of throwing on null.
		 */
		function toElements(target) {
			if (!target) {
				return [];
			}

			if (typeof target === "string") {
				return Array.prototype.slice.call(
					document.querySelectorAll(target)
				);
			}

			if (target.nodeType) {
				return [target];
			}

			if (typeof target.length === "number") {
				return Array.prototype.slice.call(target);
			}

			return [];
		}

		// Replaces the old jQuery .closest( selector ).
		function closest(target, selector) {
			var found = [];

			toElements(target).forEach(function (el) {
				var match = el.closest(selector);

				if (match && -1 === found.indexOf(match)) {
					found.push(match);
				}
			});

			return found;
		}

		// Replaces the old jQuery .find( selector ).
		function find(target, selector) {
			var found = [];

			toElements(target).forEach(function (el) {
				toElements(el.querySelectorAll(selector)).forEach(function (
					match
				) {
					if (-1 === found.indexOf(match)) {
						found.push(match);
					}
				});
			});

			return found;
		}

		// Replaces the old jQuery .next( selector ).
		function next(target, selector) {
			var found = [];

			toElements(target).forEach(function (el) {
				// .next() walks element siblings only, so nextElementSibling is
				// the match (nextSibling would return text nodes).
				var sibling = el.nextElementSibling;

				if (
					sibling &&
					sibling.matches(selector) &&
					-1 === found.indexOf(sibling)
				) {
					found.push(sibling);
				}
			});

			return found;
		}

		// Replaces the old jQuery .is( selector ) — true when ANY element matches.
		function is(target, selector) {
			return toElements(target).some(function (el) {
				return el.matches(selector);
			});
		}

		// Replaces the old jQuery .hasClass( name ) — true when ANY element has it.
		function hasClass(target, name) {
			return toElements(target).some(function (el) {
				return el.classList.contains(name);
			});
		}

		/*
		 * addClass/removeClass accept a space separated list and ignore empty
		 * tokens; classList throws on an empty token, so split the same way
		 * jQuery does. Note a value of undefined arrives here already
		 * stringified by the callers' concatenation, exactly as jQuery saw it.
		 */
		function classTokens(names) {
			return String(names)
				.split(/\s+/)
				.filter(function (name) {
					return name.length > 0;
				});
		}

		function addClass(target, names) {
			var tokens = classTokens(names);

			if (!tokens.length) {
				return;
			}

			toElements(target).forEach(function (el) {
				el.classList.add.apply(el.classList, tokens);
			});
		}

		function removeClass(target, names) {
			var tokens = classTokens(names);

			if (!tokens.length) {
				return;
			}

			toElements(target).forEach(function (el) {
				el.classList.remove.apply(el.classList, tokens);
			});
		}

		/*
		 * Replaces the old delegated jQuery .on( type, selector, fn ) on document.
		 * jQuery hands the handler the element matched by the selector (as
		 * `this`/`event.currentTarget`), which is what closest() gives us here.
		 */
		function delegate(type, selector, fn) {
			document.addEventListener(type, function (e) {
				var el =
					e.target instanceof Element ? e.target.closest(selector) : null;

				if (el) {
					fn(el, e);
				}
			});
		}

		/*
		 * Replaces .one( "webkitAnimationEnd mozAnimationEnd MSAnimationEnd
		 * oanimationend animationend", fn ). jQuery's .one() removes only the
		 * handler for the event that actually fired, leaving the other names
		 * bound, so each name gets its own one-shot listener here.
		 */
		var animationEndEvents = [
			"webkitAnimationEnd",
			"mozAnimationEnd",
			"MSAnimationEnd",
			"oanimationend",
			"animationend",
		];

		function oneAnimationEnd(el, fn) {
			animationEndEvents.forEach(function (type) {
				el.addEventListener(type, fn, { once: true });
			});
		}

		/*
		 * Replaces the old jQuery .data( key ) for values that live in the markup.
		 * jQuery reads the first element of the set; `key` is the dataset
		 * (camelCase) form of the data-* attribute. dataset is strings-only
		 * where jQuery coerced numbers/booleans/JSON, so the call sites that
		 * depend on that coercion convert explicitly.
		 */
		function dataAttr(target, key) {
			var el = toElements(target)[0];

			return el ? el.dataset[key] : undefined;
		}

		/*
		 * Replaces the old jQuery .data( key, value ) / .data( key ) for the two
		 * scroll positions. jQuery writes those into its own internal cache and
		 * never touches the DOM, returning the stored value (a number) as-is on
		 * read — so an in-memory map is the exact equivalent, and the markup
		 * stays untouched just like before.
		 */
		var popupStore = new WeakMap();

		function setPopupValue(target, key, value) {
			toElements(target).forEach(function (el) {
				var store = popupStore.get(el);

				if (!store) {
					store = {};
					popupStore.set(el, store);
				}

				store[key] = value;
			});
		}

		function getPopupValue(target, key) {
			var el = toElements(target)[0];
			var store = el ? popupStore.get(el) : null;

			return store ? store[key] : undefined;
		}

		adpPopup = {
			sPrevious: window.scrollY,
			sDirection: "down",

			/*
			 * Initialize
			 */
			init: function (e) {
				$this = adpPopup;

				$this.popupInit(e);

				// Init events.
				$this.events(e);
			},

			/*
			 * Events
			 */
			events: function (e) {
				// Custom Events
				delegate("click", ".popup-close", function (el) {
					$this.closePopup(el);
				});
				delegate("click", ".popup-accept", function (el) {
					$this.acceptPopup(el);
				});
				delegate("click", ".popup-accept", function (el) {
					$this.closePopup(el);
				});
				delegate(
					"click",
					".age-verification__popup-close",
					function (el) {
						$this.agePopup(el);
					}
				);
				delegate(
					"click",
					".age-verification__popup-close",
					function (el) {
						$this.closePopup(el);
					}
				);
				delegate("click", ".age-verification__button-no", function () {
					$this.ageDeclined();
				});

				// Checking this will cause popup to close when user presses key.
				document.addEventListener("keyup", function (e) {
					// Press ESC to Close.
					if (e.key === "Escape") {
						toElements('.popup-open[data-esc-close="true"]').forEach(
							function (popup) {
								$this.closePopup(popup);
							}
						);
					}

					// Press F4 to Close.
					if (e.key === "F4") {
						toElements('.popup-open[data-f4-close="true"]').forEach(
							function (popup) {
								$this.closePopup(popup);
							}
						);
					}
				});

				// Checking this will cause popup to close when user clicks on overlay.
				delegate("click", ".popup-overlay", function () {
					toElements('.popup-open[data-overlay-close="true"]').forEach(
						function (popup) {
							$this.closePopup(popup);
							//$this.closePopup( popup.previousElementSibling );
						}
					);
				});
			},

			/*
			 * Init popup elements
			 */
			popupInit: function (e) {
				// Set scroll direction.
				document.addEventListener("scroll", function () {
					let scrollCurrent = window.scrollY;

					// Set scroll temporary vars.
					if (scrollCurrent > $this.sPrevious) {
						$this.sDirection = "down";
					} else {
						$this.sDirection = "up";
					}

					$this.sPrevious = scrollCurrent;
				});

				// Open popup
				toElements(".popup").forEach(function (popup) {
					// Manual Launch.
					if ("manual" === dataAttr(popup, "openTrigger")) {
						let selector = dataAttr(popup, "openManualSelector");

						if (selector) {
							addClass(selector, "popup-trigger");

							delegate("click", selector, function (trigger, e) {
								e.preventDefault();

								removeClass(popup, "popup-already-opened");
								if (
									trigger.classList.contains("popup") ||
									(trigger.parentElement &&
										trigger.parentElement.closest(".popup"))
								) {
									$this.closePopup(selector);
								}
								$this.openPopup(popup);
							});
						}
					}

					// Checks whether a popup should be displayed or not.
					if (
						!$this.isAllowPopup(popup) &&
						!hasClass(popup, "age-verification")
					) {
						return;
					}

					$this.openTriggerPopup(popup);
				});
			},

			/*
			 * Trigger open popup
			 */
			openTriggerPopup: function (e) {
				let popup = e.originalEvent ? this : e;

				var trigger = dataAttr(popup, "openTrigger");

				// Age Verification.
				if ("none" === trigger) {
					let ageVerification = $this.getStorage(
						"popup-age-" + dataAttr(popup, "id") || 0
					);

					if (!ageVerification) $this.openPopup(popup);
				}

				// Time Delay.
				if ("delay" === trigger) {
					setTimeout(function () {
						$this.openPopup(popup);
					}, Number(dataAttr(popup, "openDelayNumber")) * 1000);
				}

				// Exit Intent.
				if ("exit" === trigger) {
					var showExit = true;
					document.addEventListener("mousemove", function (e) {
						// Get current scroll position
						var scroll =
							window.pageYOffset || document.documentElement.scrollTop;
						if (e.pageY - scroll < 7 && showExit) {
							$this.openPopup(popup);
							showExit = false;
						}
					});
				}

				// Scroll Position.
				if ("scroll" === trigger) {
					var pointScrollType = dataAttr(popup, "openScrollType");
					// jQuery .data() handed back a number here; the comparisons
					// below are numeric, so convert instead of comparing strings.
					var pointScrollPosition = Number(
						dataAttr(popup, "openScrollPosition")
					);

					// Event scroll.
					document.addEventListener("scroll", function () {
						// Type px.
						if ("px" === pointScrollType) {
							if (window.scrollY >= pointScrollPosition) {
								$this.openPopup(popup);
							}
						}

						// Type %.
						if ("%" === pointScrollType) {
							if ($this.getScrollPercent() >= pointScrollPosition) {
								$this.openPopup(popup);
							}
						}
					});
				}

				// Accept Agreement.
				if ("accept" === trigger) {
					let accept = $this.getStorage(
						"popup-accept-" + dataAttr(popup, "id") || 0
					);

					if (!accept) {
						$this.openPopup(popup);
					}
				}
			},

			/*
			 * Trigger close popup
			 */
			closeTriggerPopup: function (e) {
				let popup = e.originalEvent ? this : e;

				var trigger = dataAttr(popup, "closeTrigger");

				// Time Delay.
				if ("delay" === trigger) {
					setTimeout(function () {
						$this.closePopup(popup);
					}, Number(dataAttr(popup, "closeDelayNumber")) * 1000);
				}

				// Scroll Position.
				if ("scroll" === trigger) {
					var pointScrollType = dataAttr(popup, "closeScrollType");
					// Numeric comparisons below — jQuery .data() coerced these.
					var pointScrollPosition = Number(
						dataAttr(popup, "closeScrollPosition")
					);
					// Written by openPopup() through jQuery's data cache, never
					// to the markup — see setPopupValue().
					var initScrollPx = getPopupValue(popup, "init-scroll-px");
					var initScrollPercent = getPopupValue(
						popup,
						"init-scroll-percent"
					);

					// Event scroll.
					document.addEventListener("scroll", function () {
						// Type px.
						if ("px" === pointScrollType) {
							if (
								"up" === $this.sDirection &&
								window.scrollY < initScrollPx - pointScrollPosition
							) {
								$this.closePopup(popup);
							}

							if (
								"down" === $this.sDirection &&
								window.scrollY >= initScrollPx + pointScrollPosition
							) {
								$this.closePopup(popup);
							}
						}

						// Type %.
						if ("%" === pointScrollType) {
							if (
								"up" === $this.sDirection &&
								$this.getScrollPercent() <
									initScrollPercent - pointScrollPosition
							) {
								$this.closePopup(popup);
							}

							if (
								"down" === $this.sDirection &&
								$this.getScrollPercent() >=
									initScrollPercent + pointScrollPosition
							) {
								$this.closePopup(popup);
							}
						}
					});
				}
			},

			/*
			 * Open popup
			 */
			openPopup: function (e) {
				let popup = e.originalEvent ? this : e;

				// Hide body scroll.
				if (is(popup, '[data-body-scroll-disable="true"]')) {
					addClass(document.body, "popup-scroll-hidden");
				}

				// Set Storage of Limit display.
				let limit =
					parseInt(
						$this.getStorage("popup-" + dataAttr(popup, "id")) || 0
					) + 1;

				$this.setStorage("popup-" + dataAttr(popup, "id"), limit, {
					// setStorage only tests this for truthiness before parsing
					// it, and jQuery .data() returned a number: the string "0"
					// would be truthy where the number 0 is not.
					expires: Number(dataAttr(popup, "limitLifetime")),
				});

				if (hasClass(popup, "popup-open")) {
					return;
				}

				// Check already opened.
				if (hasClass(popup, "popup-already-opened")) {
					return;
				}

				// Display popup.
				addClass(popup, "popup-open");

				// Set current scroll.
				// jQuery cached these in memory rather than writing them to the
				// markup, and read them back as numbers — see setPopupValue().
				setPopupValue(popup, "init-scroll-px", window.scrollY);
				setPopupValue(
					popup,
					"init-scroll-percent",
					$this.getScrollPercent()
				);

				// Open animation.
				let animation = dataAttr(popup, "openAnimation");

				$this.applyAnimation(popup, animation);

				// Init close trigger.
				$this.closeTriggerPopup(popup);
			},

			/*
			 * Age popup
			 */
			agePopup: function (e) {
				let $el = e.originalEvent ? this : e;

				// Get popup container.
				let popup = closest($el, ".popup");

				// Set Storage of Age.
				$this.setStorage("popup-age-" + dataAttr(popup, "id"), 1, {
					expires: 360,
				});
			},

			/*
			 * Age declined
			 */

			ageDeclined: function () {
				removeClass(".age-verification__question", "show");
				addClass(".age-verification__declined", "show");
			},

			/*
			 * Accept popup
			 */
			acceptPopup: function (e) {
				let $el = e.originalEvent ? this : e;

				// Get popup container.
				let popup = closest($el, ".popup");

				// Set Storage of Accept.
				$this.setStorage("popup-accept-" + dataAttr(popup, "id"), 1, {
					expires: 360,
				});
			},

			/*
			 * Close popup
			 */
			closePopup: function (e) {
				let $el = e.originalEvent ? this : e;

				// Get popup container.
				let popup = closest($el, ".popup");
				// Close animation.
				let animation = dataAttr(popup, "exitAnimation");

				$this.applyAnimation(popup, animation, function () {
					// Already opened.
					addClass(popup, "popup-already-opened");

					// Hide popup.
					removeClass(popup, "popup-open");
				});
				// Remove classes from body.
				removeClass(document.body, "popup-scroll-hidden");
			},

			/*
			 * Checks whether a popup should be displayed or not
			 */
			isAllowPopup: function (e) {
				let popup = e.originalEvent ? this : e;

				// Has user seen this popup before?
				let limitDisplay = parseInt(dataAttr(popup, "limitDisplay") || 0);

				let limitDisplayCookie = parseInt(
					$this.getStorage("popup-" + dataAttr(popup, "id"))
				);

				if (
					limitDisplay &&
					limitDisplayCookie &&
					limitDisplayCookie >= limitDisplay
				) {
					return;
				}

				return true;
			},

			/*
			 * Apply animation
			 */
			applyAnimation: function (el, name, callback) {
				var popup = closest(el, ".popup");

				if (typeof callback === "function") {
					var overlayName = "popupExitFade";
				} else {
					var overlayName = "popupOpenFade";
				}

				// Overlay Animation.
				next(popup, ".popup-overlay").forEach(function (overlay) {
					addClass(overlay, "popup-animated " + overlayName);

					oneAnimationEnd(overlay, function () {
						removeClass(overlay, "popup-animated " + overlayName);
					});
				});

				// Wrap Animation.
				find(popup, ".popup-wrap").forEach(function (wrap) {
					addClass(wrap, "popup-animated " + name);

					oneAnimationEnd(wrap, function () {
						// remove the animation classes after animation ends
						// required in order to apply new animation on close
						removeClass(wrap, "popup-animated " + name);

						if (typeof callback === "function") {
							callback();
						}
					});
				});
			},

			/*
			 * Set cookie
			 */
			getCookie: function (name) {
				var matches = document.cookie.match(
					new RegExp(
						"(?:^|; )" +
							name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
							"=([^;]*)"
					)
				);
				return matches ? decodeURIComponent(matches[1]) : undefined;
			},

			/*
			 * Set cookie
			 */
			setCookie: function (name, value, options) {
				options = options || {};

				options.path = options.hasOwnProperty("path") ? options.path : "/";

				options.expires = parseInt(options.expires);

				if (typeof options.expires == "number" && options.expires) {
					options.expires = new Date().setDate(
						new Date().getDate() + options.expires
					);

					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent(value);

				var updatedCookie = name + "=" + value;

				for (var propName in options) {
					updatedCookie += "; " + propName;
					var propValue = options[propName];
					if (propValue !== true) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			/*
			 * Get local storage
			 */
			getStorage: function (key) {
				const item = localStorage.getItem(key);
				if (item) {
					try {
						const parsed = JSON.parse(item);
						if (parsed.expires && Date.now() > parsed.expires) {
							localStorage.removeItem(key);
							return undefined;
						}
						return parsed.value;
					} catch {
						return undefined;
					}
				}
				const cookieValue = $this.getCookie(key);
				if (cookieValue !== undefined) {
					// Optional: migrate cookie to localStorage
					$this.setStorage(key, cookieValue);
					return cookieValue;
				}
				return undefined;
			},

			/*
			 * Set local storage
			 */
			setStorage: function (key, value, options = {}) {
				const data = {
					value,
					expires: null,
				};
				if (options.expires) {
					const expiresDate = new Date();
					expiresDate.setDate(
						expiresDate.getDate() + parseInt(options.expires, 10)
					);
					data.expires = expiresDate.getTime();
				}
				localStorage.setItem(key, JSON.stringify(data));
			},

			/*
			 * Get scroll percent
			 */
			getScrollPercent: function () {
				var h = document.documentElement,
					b = document.body,
					st = "scrollTop",
					sh = "scrollHeight";
				return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
			},
		};
	})();

	function onReady() {
		// Initialize.
		adpPopup.init();

		document.addEventListener("shopify:section:load", function () {
			adpPopup.init();
		});
	}

	/*
	 * Replaces jQuery( document ).ready(). This file is deferred, so the DOM can
	 * already be parsed by the time it runs — DOMContentLoaded would never fire
	 * again in that case, so call straight through.
	 */
	if ("loading" === document.readyState) {
		document.addEventListener("DOMContentLoaded", onReady);
	} else {
		onReady();
	}
})();
